import { render } from "./FireProfilePage.vue?vue&type=template&id=2d877a0c"
import script from "./FireProfilePage.vue?vue&type=script&lang=ts"
export * from "./FireProfilePage.vue?vue&type=script&lang=ts"
script.render = render

export default script